function timeFormat(time, completeMinutes = false) {
	const minutes = Math.floor(time / 60)
	let remainingSeconds = Math.floor(time - minutes * 60)
	remainingSeconds = (remainingSeconds < 10 ? '0' : '') + remainingSeconds.toString()
	let format_time = minutes + ':' + remainingSeconds
	if (completeMinutes && minutes < 10)
		format_time = '0' + format_time

	return format_time
}

export default timeFormat
